import { FastField } from 'formik';
import KTFormGroup from 'general/components/OtherKeenComponents/Forms/KTFormGroup';
import KTFormInput, { KTFormInputType } from 'general/components/OtherKeenComponents/Forms/KTFormInput';
import AppColors from 'general/constants/AppColors';
import { useTranslation } from 'react-i18next';
import { Row, Col, Modal } from 'react-bootstrap';
import KTRadio, { KTRadioType } from 'general/components/OtherKeenComponents/KTFormControls/KTRadio';
import Utils from 'general/utils/Utils';

function LandlordCommissionView({
    formikProps,
    commissionGrounds,
    isDisabled,
}) {
    const { t } = useTranslation();

    return (
        <Row>
            <Col md={12}>
                <Modal.Title className="mb-3">
                    <span
                        className="font-weight-bolder"
                        style={{ fontSize: 18, color: AppColors.gray[900] }}
                    >
                        Hoa hồng giới thiệu mặt bằng
                    </span>
                </Modal.Title>
            </Col>
            <Col md={12}>
                <KTFormGroup
                    label=""
                    inputName="landlordCommissionType"
                    additionalLabelClassName="w-160px"
                    additionalClassName="mb-0 d-flex"
                    inputElement={
                        <div className="radio-inline w-100">
                            <FastField name="landlordCommissionType">
                                {({ field, form, meta }) => (
                                    <div className="d-flex gap-5">
                                        <KTRadio
                                            name={'Hoa hồng kết hợp'}
                                            checked={field.value === 'Hoa hồng kết hợp'}
                                            label={'Hoa hồng kết hợp'}
                                            type={KTRadioType.outline}
                                            additionalClassName="radio-success"
                                            onChange={() => {
                                                form.setFieldValue(field.name, 'Hoa hồng kết hợp');
                                            }}
                                            enableCheckValid
                                            isValid={_.isEmpty(meta.error)}
                                            isTouched={meta.touched}
                                            feedbackText={meta.error}
                                            disabled={isDisabled}
                                        />
                                        <KTRadio
                                            name={'Hoa hồng cố định'}
                                            checked={field.value === 'Hoa hồng cố định'}
                                            label={'Hoa hồng cố định'}
                                            type={KTRadioType.outline}
                                            additionalClassName="radio-success"
                                            onChange={() => {
                                                form.setFieldValue(field.name, 'Hoa hồng cố định');
                                            }}
                                            enableCheckValid
                                            isValid={_.isEmpty(meta.error)}
                                            isTouched={meta.touched}
                                            feedbackText={meta.error}
                                            disabled={isDisabled}
                                        />
                                        <KTRadio
                                            name={'Hoa hồng theo doanh thu điện'}
                                            checked={field.value === 'Hoa hồng theo doanh thu điện'}
                                            label={'Hoa hồng theo doanh thu điện'}
                                            type={KTRadioType.outline}
                                            additionalClassName="radio-success"
                                            onChange={() => {
                                                form.setFieldValue(field.name, 'Hoa hồng theo doanh thu điện');
                                            }}
                                            enableCheckValid
                                            isValid={_.isEmpty(meta.error)}
                                            isTouched={meta.touched}
                                            feedbackText={meta.error}
                                            disabled={isDisabled}
                                        />
                                    </div>
                                )}
                            </FastField>
                        </div>
                    }
                />
            </Col>
            {(formikProps.values.landlordCommissionType === 'Hoa hồng kết hợp' || formikProps.values.landlordCommissionType === 'Hoa hồng theo doanh thu điện') && (
                <>
                    <Col md={12} >
                        <div className="mt-2 mb-4" style={{ borderBottom: `1px dashed ${AppColors.gray[300]}` }} />
                    </Col>
                    <Col md={6} className='pr-lg-2 pr-md-2 pr-0'>
                        <KTFormGroup
                            label={<span className="font-weight-bolder" style={{ color: AppColors.gray[800], fontSize: Utils.returnFontSize(13), fontWeight: 700 }}>{t('Mức chia sẻ theo kW điện')} </span>}
                            inputName="landlordEnergyCommissionValue"
                            additionalClassName="mb-0"
                            inputElement={
                                <FastField name="landlordEnergyCommissionValue">
                                    {({ field, form, meta }) => (
                                        <KTFormInput
                                            name={field.name}
                                            value={field.value}
                                            onChange={(value) => form.setFieldValue(field.name, value)}
                                            onBlur={() => form.setFieldTouched(field.name, true)}
                                            enableCheckValid
                                            type={KTFormInputType.currency}
                                            placeholder={t('enterNumber')}
                                            isValid={_.isEmpty(meta.error)}
                                            isTouched={meta.touched}
                                            feedbackText={meta.error}
                                            unit='VNĐ/kWh'
                                            disabled={isDisabled}
                                        />
                                    )}
                                </FastField>
                            }
                            isRequired={true}
                        />
                    </Col>
                    <Col md={6} className='pl-lg-2 pl-md-2 pl-0'>
                        <KTFormGroup
                            label={<span className="font-weight-bolder" style={{ color: AppColors.gray[800], fontSize: Utils.returnFontSize(13), fontWeight: 700 }}>{t('Thời gian áp dụng')} </span>}
                            inputName="commissionDuration"
                            additionalClassName="mb-0"
                            inputElement={
                                <FastField name="commissionDuration">
                                    {({ field, form, meta }) => (
                                        <KTFormInput
                                            name={field.name}
                                            value={field.value}
                                            onChange={(value) => form.setFieldValue(field.name, value)}
                                            onBlur={() => form.setFieldTouched(field.name, true)}
                                            enableCheckValid
                                            type={KTFormInputType.text}
                                            placeholder={t('enterNumber')}
                                            isValid={_.isEmpty(meta.error)}
                                            isTouched={meta.touched}
                                            feedbackText={meta.error}
                                            unit='Tháng'
                                            disabled={isDisabled}
                                        />
                                    )}
                                </FastField>
                            }
                            isRequired={true}
                        />
                    </Col>
                </>
            )}
            {(formikProps.values.landlordCommissionType === 'Hoa hồng kết hợp' || formikProps.values.landlordCommissionType === 'Hoa hồng cố định') && (
                <>
                    <Col md={12} >
                        <div className="mt-4 mb-4" style={{ borderBottom: `1px dashed ${AppColors.gray[300]}` }} />
                    </Col>
                    {!commissionGrounds?.find(commission => commission?.key === formikProps?.values?.type)?.show
                        ? (
                            <Col md={6} className={`pr-lg-2 pr-md-2 pr-0`}>
                                <KTFormGroup
                                    label={<span className="font-weight-bolder" style={{ color: AppColors.gray[800], fontSize: Utils.returnFontSize(13), fontWeight: 700 }}>{t('Số tiền cố định')} </span>}
                                    inputName="fixEnergyCommissionValueLandlord"
                                    additionalClassName=" mb-0"
                                    inputElement={
                                        <FastField name="fixEnergyCommissionValueLandlord">
                                            {({ field, form, meta }) => (
                                                <KTFormInput
                                                    name={field.name}
                                                    value={field.value}
                                                    onChange={(value) => form.setFieldValue(field.name, value)}
                                                    onBlur={() => form.setFieldTouched(field.name, true)}
                                                    enableCheckValid
                                                    type={KTFormInputType.currency}
                                                    placeholder={t('enterNumber')}
                                                    isValid={_.isEmpty(meta.error)}
                                                    isTouched={meta.touched}
                                                    feedbackText={meta.error}
                                                    unit='VNĐ'
                                                    disabled={isDisabled}
                                                />
                                            )}
                                        </FastField>
                                    }
                                    isRequired={true}
                                />
                            </Col>
                        )
                        : (
                            <>
                                <Col md={6} className={`pr-lg-2 pr-md-2 pr-0`}>
                                    <KTFormGroup
                                        label={<span className="font-weight-bolder" style={{ color: AppColors.gray[800], fontSize: Utils.returnFontSize(13), fontWeight: 700 }}>{t('Loại phương tiện')} </span>}
                                        inputName="car"
                                        additionalClassName=" mb-4"
                                        inputElement={
                                            <FastField name="car">
                                                {({ field, form, meta }) => (
                                                    <KTFormInput
                                                        name={field.name}
                                                        value={'Ô tô'}
                                                        onChange={(value) => form.setFieldValue(field.name, value)}
                                                        onBlur={() => form.setFieldTouched(field.name, true)}
                                                        enableCheckValid
                                                        type={KTFormInputType.text}
                                                        placeholder={t('enterNumber')}
                                                        isValid={_.isEmpty(meta.error)}
                                                        isTouched={meta.touched}
                                                        feedbackText={meta.error}
                                                        disabled={true}
                                                    />
                                                )}
                                            </FastField>
                                        }
                                        isRequired={true}
                                    />
                                </Col>
                                <Col md={6} className={`pl-lg-2 pl-md-2 pl-0`}>
                                    <KTFormGroup
                                        label={<span className="font-weight-bolder" style={{ color: AppColors.gray[800], fontSize: Utils.returnFontSize(13), fontWeight: 700 }}>{t('Số tiền cố định')} </span>}
                                        inputName="fixEnergyCommissionValueByCar"
                                        additionalClassName=" mb-0"
                                        inputElement={
                                            <FastField name="fixEnergyCommissionValueByCar">
                                                {({ field, form, meta }) => (
                                                    <KTFormInput
                                                        name={field.name}
                                                        value={field.value}
                                                        onChange={(value) => form.setFieldValue(field.name, value)}
                                                        onBlur={() => form.setFieldTouched(field.name, true)}
                                                        enableCheckValid
                                                        type={KTFormInputType.currency}
                                                        placeholder={t('enterNumber')}
                                                        isValid={_.isEmpty(meta.error)}
                                                        isTouched={meta.touched}
                                                        feedbackText={meta.error}
                                                        unit='VNĐ'
                                                        disabled={isDisabled}
                                                    />
                                                )}
                                            </FastField>
                                        }
                                        isRequired={true}
                                    />
                                </Col>
                                <Col md={6} className={`pr-lg-2 pr-md-2 pr-0`}>
                                    <KTFormGroup
                                        label={<span className="font-weight-bolder" style={{ color: AppColors.gray[800], fontSize: Utils.returnFontSize(13), fontWeight: 700 }}>{t('Loại phương tiện')} </span>}
                                        inputName="bike"
                                        additionalClassName=" mb-0"
                                        inputElement={
                                            <FastField name="bike">
                                                {({ field, form, meta }) => (
                                                    <KTFormInput
                                                        name={field.name}
                                                        value={'Xe máy'}
                                                        onChange={(value) => form.setFieldValue(field.name, value)}
                                                        onBlur={() => form.setFieldTouched(field.name, true)}
                                                        enableCheckValid
                                                        type={KTFormInputType.text}
                                                        placeholder={t('enterNumber')}
                                                        isValid={_.isEmpty(meta.error)}
                                                        isTouched={meta.touched}
                                                        feedbackText={meta.error}
                                                        disabled={true}
                                                    />
                                                )}
                                            </FastField>
                                        }
                                        isRequired={true}
                                    />
                                </Col>
                                <Col md={6} className={`pl-lg-2 pl-md-2 pl-0`}>
                                    <KTFormGroup
                                        label={<span className="font-weight-bolder" style={{ color: AppColors.gray[800], fontSize: Utils.returnFontSize(13), fontWeight: 700 }}>{t('Số tiền cố định')} </span>}
                                        inputName="fixEnergyCommissionValueByBike"
                                        additionalClassName=" mb-0"
                                        inputElement={
                                            <FastField name="fixEnergyCommissionValueByBike">
                                                {({ field, form, meta }) => (
                                                    <KTFormInput
                                                        name={field.name}
                                                        value={field.value}
                                                        onChange={(value) => form.setFieldValue(field.name, value)}
                                                        onBlur={() => form.setFieldTouched(field.name, true)}
                                                        enableCheckValid
                                                        type={KTFormInputType.currency}
                                                        placeholder={t('enterNumber')}
                                                        isValid={_.isEmpty(meta.error)}
                                                        isTouched={meta.touched}
                                                        feedbackText={meta.error}
                                                        unit='VNĐ'
                                                        disabled={isDisabled}
                                                    />
                                                )}
                                            </FastField>
                                        }
                                        isRequired={true}
                                    />
                                </Col>
                            </>
                        )}
                </>
            )}
        </Row>
    )
}

export default LandlordCommissionView;